<template>
    <v-autocomplete
            label="Tipo de item"
            :items="items"
            :value="value"
            :multiple="multiple"
            :chips="chips"
            item-value="id"
            item-text="desig"
            hide-details
            @input="actualizaValor($event)"
            @change="change($event)"
            clearable
            :readonly="readonly"
    >
    </v-autocomplete>
</template>
<script>
    import mixinListas from '../mixins/items';

    export default {
        name: 'tipo-item-select',
        props: ['multiple', 'value', 'chips', 'readonly',],
        mixins: [mixinListas],
        data() {
            return {
                items: []
            }
        },
        mounted() {
            this.itemTipos(r => {
                this.items = r;
            }, err => {
                console.log(err)
            })
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor)
            },
            change(e) {
                this.$emit('change', e);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/TipoItemSelect.vue